import { GlIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import SafeHtml from '~/vue_shared/directives/safe_html';
import TimeAgoTooltip from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/time_ago_tooltip.vue?vue3';
import NoteAuthor from './note_author.vue';
import TimelineEntryItem from './timeline_entry_item.vue';
export default {
    name: 'SystemNote',
    components: {
        TimeAgoTooltip,
        NoteAuthor,
        TimelineEntryItem,
        GlIcon
    },
    directives: {
        SafeHtml
    },
    props: {
        note: {
            type: Object,
            required: true
        },
        isLastDiscussion: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
